// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__2qqJ4","boxTitle":"Qualiphy_boxTitle__3wO0N","box":"Qualiphy_box__3d7aG","toggleWrap":"Qualiphy_toggleWrap__2cuOK"};